module.exports = __webpack_public_path__ + "img/nature20.c4fb8cf6.jpg";